import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import SectionContainer from "core/SectionContainer";
import Thumbnail from "./Thumbnail";
import IconCollectionBuyBox from "../IconCollectionBuyBox";
import Skeleton from "core/Skeleton";

import colors from "core/colors";
import breakpoints from "core/breakpoints";
import { convertPxToRem } from "frontend/components/helpers";
import propTypes from "../IconCollectionDetailHero/propTypes";

const ContentContainer = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    column-gap: ${convertPxToRem(24)};
    row-gap: ${convertPxToRem(24)};
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        grid-template-columns: 1fr;
    }
`;

const IconCollectionDetailHero = ({
    collectionId = "",
    collectionName,
    creatorName,
    creatorCountry,
    creatorUsername,
    creatorAvatarUrl,
    totalIconCount,
    iconTitleAndThumbnailList = [],
    userSubscriptionType,
    isNewCreativeProSubscriber = false,
    showCollectionFortLink = false,
    loading
}) => {
    const [buyBoxHeight, setBuyBoxHeight] = useState(0);

    if (loading) return <Skeleton height={convertPxToRem(200)} width="100%" />;

    return (
        <SectionContainer
            bgColor={colors.secondary.orca}
            topSpacing="2xl"
            bottomSpacing="2xl"
        >
            <ContentContainer>
                <Thumbnail
                    iconTitleAndThumbnailList={iconTitleAndThumbnailList}
                    thumbnailHeight={buyBoxHeight}
                    collectionId={collectionId}
                    showCollectionFortLink={showCollectionFortLink}
                />
                <IconCollectionBuyBox
                    setBuyBoxHeight={setBuyBoxHeight}
                    collectionName={collectionName}
                    creatorName={creatorName}
                    creatorCountry={creatorCountry}
                    creatorAvatarUrl={creatorAvatarUrl}
                    creatorUsername={creatorUsername}
                    totalIconCount={totalIconCount}
                    userSubscriptionType={userSubscriptionType}
                    isNewCreativeProSubscriber={isNewCreativeProSubscriber}
                />
            </ContentContainer>
        </SectionContainer>
    );
};

IconCollectionDetailHero.propTypes = {
    ...propTypes,
    iconTitleAndThumbnailList: PropTypes.arrayOf(PropTypes.object.isRequired)
        .isRequired,
    collectionId: PropTypes.string.isRequired,
    showCollectionFortLink: PropTypes.bool,
    isNewCreativeProSubscriber: PropTypes.bool,
    userSubscriptionType: PropTypes.oneOf([
        "none",
        "individual_pro",
        "team",
        "edu",
        "creative_pro"
    ])
};

export default IconCollectionDetailHero;
